import { useTheme } from '@shopify/restyle';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Trans } from 'react-i18next';
import { useScopedTranslation } from 'app/hooks/i18n';
import OneMonthFreeCard from 'app/components/one-month-free-card';
import type { Theme } from 'app/shopify';
import { HowItWorksStep } from './how-it-works-step';

export function HowItWorksCard({
  isReferralProgram,
  isReferralProgram202506,
  tPrefix,
}: {
  isReferralProgram: boolean;
  isReferralProgram202506: boolean;
  tPrefix: string;
}) {
  const { t } = useScopedTranslation();
  const theme = useTheme<Theme>();
  if (!isReferralProgram202506 && !isReferralProgram) return null;
  return (
    <Column
      alignItems="center"
      gap="spacing.general.x5"
      style={{
        borderColor: theme.colors['surface.tertiary'],
        borderRadius: theme.borderRadii['radius.xl'],
        borderWidth: 1,
        padding: theme.spacing['spacing.general.x4'],
      }}
    >
      <Text fontWeight="700" textAlign="center" variant="headerXSmall">
        {t(`${tPrefix}howItWorks.title`)}
      </Text>
      <Text marginHorizontal="spacing.general.x4" textAlign="center" variant="bodyBase">
        {t(`${tPrefix}howItWorks.subtitle`)}
      </Text>
      <Row
        style={{
          backgroundColor: theme.colors['surface.brand.subtle'],
          padding: theme.spacing['spacing.general.x2'],
          borderRadius: theme.borderRadii['radius.lg'],
          flex: 3,
        }}
      >
        <HowItWorksStep emoji="🤳" label={t(`${tPrefix}howItWorks.step1`)} />
        <HowItWorksStep emoji="☺️" label={t(`${tPrefix}howItWorks.step2`)} />
        <HowItWorksStep emoji="🎁" label={t(`${tPrefix}howItWorks.step3`)} />
      </Row>
      <Text
        marginHorizontal="spacing.general.x4"
        textAlign="center"
        variant="bodyBase"
        lineHeight={22}
        style={{ color: theme.colors['text.secondary'] }}
      >
        <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey={`${tPrefix}gift.prefix`} ns="invite" />
      </Text>
      {isReferralProgram202506 ? (
        <Row style={{ padding: theme.spacing['spacing.general.x2'], flex: 3 }}>
          <HowItWorksStep emoji="🛒" label={t(`${tPrefix}gift.gift1`)} outlined />
          <HowItWorksStep emoji="🚇" label={t(`${tPrefix}gift.gift2`)} outlined />
          <HowItWorksStep emoji="❤️" label={t(`${tPrefix}gift.gift3`)} outlined />
        </Row>
      ) : (
        <OneMonthFreeCard />
      )}
    </Column>
  );
}
